module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-italic.d631fe7.woff2";